import React from 'react';
import PropTypes from 'prop-types';
import useBreakpointRef from '../../../hooks/useBreakpointRef';

const BREAKPOINTS = Object.freeze([744, 1128]);
const BREAKPOINT_VALUES = Object.freeze(['none', '744px', '1128px']);
const CONTAINER_STYLE = Object.freeze({
  display: 'flex',
  flexDirection: 'row',
  width: '100%'
});

const DisplayWidthForBreakpoints = ({ children }) => {
  const { ref, breakpointValue } = useBreakpointRef({
    breakpoints: BREAKPOINTS,
    breakpointValues: BREAKPOINT_VALUES
  });

  return (
    <div ref={ref} style={CONTAINER_STYLE}>
      {breakpointValue ?
        <div style={{ margin: '0 auto', width: '100%', maxWidth: breakpointValue }}>
          {children}
        </div>
        : null}
    </div>
  );
};

DisplayWidthForBreakpoints.propTypes = {
  children: PropTypes.node
};

export default DisplayWidthForBreakpoints;
